import { BrokerConfigDto, QueueConfigDto, TopicConfigDto } from '../types/rest/mockServiceTypes';
import { MessagingSourceType } from '../types/rest/assetCatalogTypes';
import { MultipleSelectItem } from '../components/selectors/MultipleSelect';
import _ from 'lodash';

const mapItems = (
  configItems: QueueConfigDto[] | TopicConfigDto[],
  type: MessagingSourceType,
): MultipleSelectItem[] => {
  return _.map(
    configItems,
    item => ({ label: `(${type}) ${item.name}`, value: item.name, metadata: { type: type } } as MultipleSelectItem),
  );
};
export const getMappingItems = (brokerConfig: BrokerConfigDto) => {
  if (_.isNil(brokerConfig)) {
    return [];
  }
  const topics = mapItems(brokerConfig.topics, 'TOPIC');
  const queues = mapItems(brokerConfig.queues, 'QUEUE');
  const subscriptions = mapItems(brokerConfig.subscriptions, 'SUBSCRIPTION');
  return _.union(queues, topics, subscriptions);
};
